import { mergeSx } from "@/utils";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";

import { SvgIcon } from "../SvgIcon";

export function ImmutableVerticalLockup({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("ImmutableVerticalLockup");
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 123 96"
      sx={mergeSx(
        {
          fill: "base.color.brand.1",
          w: "123px",
        },
        sx,
      )}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}

ImmutableVerticalLockup.displayName = "ImmutableVerticalLockup";
